import { Picture } from "@/components/wpl/image/src";

export const FlareSvg = () => (
    <Picture
        image={{
            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/8ra1mh2pbsd5j7i3kc5rdw2h5815w1i1.svg",
            alt: "",
            width: 77,
            height: 81
        }}
    />
);
